const EMPTY_ARRAY = [];

// Whether a poll left the widget's submissions as they were, so the list can keep its rows and the reader's scroll
// position.
export function isSameSubmissions(previous, next) {
  if (!previous) {
    return false;
  }

  const previousIds = Object.keys(previous);
  const nextIds = Object.keys(next);

  return previousIds.length === nextIds.length
    && nextIds.every(rowId => isSameSubmission(previous[rowId], next[rowId]));
}

// An edit leaves a row's last modified date where it was, so the answers are compared too. All of the row's answers,
// not only the one shown: the widget's filter reads the others, and an edit to one of them can move the row in or out.
function isSameSubmission(previous, next) {
  if (previous === next) {
    return true;
  }

  return Boolean(previous)
    && previous.lastModified === next.lastModified
    && getAnswersKey(previous.rowAnswers) === getAnswersKey(next.rowAnswers);
}

// The API holds a row's answers as a set, so the same answers can come back in a different order.
function getAnswersKey(answers) {
  return JSON.stringify((answers || EMPTY_ARRAY)
    .map(answer => [answer.id, answer.questionId, answer.value])
    .sort((a, b) => String(a[0]).localeCompare(String(b[0]))));
}
